var map = {
	"./note-1-color.svg": 51,
	"./note-1.svg": 25,
	"./note-2-color.svg": 52,
	"./note-2.svg": 26,
	"./note-3.svg": 27,
	"./note-4.svg": 28,
	"./note-5-color.svg": 53,
	"./note-5.svg": 29,
	"./note-6.svg": 30,
	"./note-7.svg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;